import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import classnames from 'classnames/bind';
import styles from './dotChart.module.scss';

const cx = classnames.bind(styles);

const Arrow = () => {
  return (
    <>
      <i className={cx('arrow', 'top')} />
      <i className={cx('arrow', 'right')} />
    </>
  );
};

const Line = () => {
  return (
    <>
      <i className={cx('line', 'horizontal')} />
      <i className={cx('line', 'vertical')} />
    </>
  );
};

const Category = () => {
  return (
    <>
      <span className={cx('category', 'leftTop')}>역량에 잘 맞아요</span>
      <span className={cx('category', 'leftBottom')}>역량에 안 맞아요</span>
      <span className={cx('category', 'bottomLeft')}>유형에 안 맞아요</span>
      <span className={cx('category', 'bottomRight')}>유형에 잘 맞아요</span>
    </>
  );
};

const Preference = () => {
  return (
    <>
      <div className={cx('preference', 'topLeft', 'gray')}>보통</div>
      <div className={cx('preference', 'topRight', 'green')}>추천</div>
      <div className={cx('preference', 'bottomLeft', 'red')}>고민 필요</div>
      <div className={cx('preference', 'bottomRight', 'gray')}>보통</div>
    </>
  );
};

interface Item {
  index: number;
  activeIndex: number;
  setActiveIndex: (activeIndex: number) => void;
  title: string;
  position: { x: number; y: number };
  color: string;
}

const Item = ({ index, activeIndex, setActiveIndex, title, position, color }: Item) => {
  const x = position.x < 0 ? 0 : position.x > 10 ? 10 : position.x;
  const y = position.y < 0 ? 0 : position.y > 12 ? 12 : position.y;
  const alignItems = x <= 0 ? 'flex-start' : x >= 10 ? 'flex-end' : 'center';

  const getLeft = (x: number) => {
    if (x <= 5) {
      return 16 + x * 50;
    } else {
      return 16 + 6 * 50 + (x - 6) * 58;
    }
  };

  const getBottom = (y: number) => {
    return 24 * (y + 1);
  };

  return (
    <div
      className={cx(
        'item',
        color,
        { active: index === activeIndex },
        { inActive: activeIndex >= 0 && index !== activeIndex },
      )}
      style={{
        bottom: `${getBottom(y)}px`,
        left: `${getLeft(x)}px`,
        alignItems: alignItems,
      }}
    >
      <i className={cx('point')} />
      <span
        className={cx('title')}
        style={{
          justifyContent: alignItems,
        }}
        onClick={() => {
          setActiveIndex(index);
        }}
      >
        {title}
      </span>
    </div>
  );
};

interface Items {
  activeIndex: number;
  setActiveIndex: (activeIndex: number) => void;
}

const Items = ({ activeIndex, setActiveIndex }: Items) => {
  const { accaResultStore } = useResultStore();
  const { accJobCuration } = accaResultStore;

  if (!accJobCuration) return null;

  const { jobRankings } = accJobCuration;

  if (!jobRankings) return null;

  const items = jobRankings.map((aiJobCuration, index) => {
    const { jobGroup, typeRank, competenceRank } = aiJobCuration;
    const getColor = () => {
      if (typeRank <= 5 && competenceRank <= 6) return 'green';
      if (typeRank >= 6 && competenceRank >= 7) return 'red';
      return 'common';
    };

    return (
      <Item
        key={index}
        index={index}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        title={jobGroup.name}
        position={{ x: 11 - typeRank, y: 12 - competenceRank }}
        color={getColor()}
      />
    );
  });

  return <div className={cx('itemArea')}>{items}</div>;
};

interface DotChart {
  activeIndex: number;
  setActiveIndex: (activeIndex: number) => void;
}

const DotChart = ({ activeIndex, setActiveIndex }: DotChart) => {
  return (
    <div className={cx('dotChart')}>
      <Arrow />
      <Line />
      <Category />
      <Preference />
      <Items activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
    </div>
  );
};

export default DotChart;
